module.exports = __webpack_public_path__ + "img/cards.09c3c061.png";